import React from "react";
import { useAuth } from "@/GlobalData";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router";

function Login() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [remember, setRemember] = React.useState(false);
  const authContext = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: unknown) => {
    const ev = e as FormDataEvent
    ev.preventDefault();
    console.log({ email, password, remember });
    try {
      await signInWithEmailAndPassword(authContext.auth, email, password)
      navigate("/profile")
    } catch (e) {
      const err = e as Error
      alert("Error " + err.message)
    }
  };

  return (
    <div className="min-h-screen w-full bg-white font-sans be-vietnam-pro-regular">
      <div className="mx-auto max-w-7xl lg:max-w-none">
        <div className="grid min-h-screen grid-cols-1 lg:grid-cols-5">

          {/* Left panel - hanya muncul di layar besar */}
          <div className="hidden lg:flex relative bg-[#184D47] px-6 py-10 sm:px-10 lg:col-span-3 lg:px-12 items-center">
            <div className="w-full max-w-xl mx-auto">
              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg ring-1 ring-black/5 flex flex-col items-center text-center gap-6 lg:gap-8">
                <div className="w-[400px] h-[250px] flex-shrink-0">
                  <img
                    src={new URL('~/src/assets/people.png', import.meta.url).href}
                    alt="People"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="flex flex-col items-center gap-3 sm:gap-4 px-2">
                  <h2 className="text-[#184D47] text-2xl sm:text-3xl lg:text-4xl font-semibold leading-snug">
                    Belajar Kapan Saja dan Di Mana Saja
                  </h2>
                  <p className="text-gray-700 text-base sm:text-lg leading-relaxed max-w-prose">
                    Ikuti pelatihan online bersama para profesional untuk mengasah kemampuan dan memperluas wawasan.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right panel - full width di mobile */}
          <div className="flex flex-col items-center justify-center px-6 py-10 sm:px-10 lg:col-span-2 lg:px-12 bg-transparent bg-bottom bg-repeat-x"
            style={{
              backgroundImage: `url(${new URL('~/src/assets/pattern.png', import.meta.url).href})`,
              backgroundSize: 'auto',
            }}>

            {/* Brand */}
            <div className="flex items-center w-[200px] h-max flex-shrink-1">
              <img src={new URL('~/src/assets/applogo.png', import.meta.url).href} alt="App logo" />
            </div>


            {/* Form */}
            <form onSubmit={handleSubmit} className="w-full max-w-md">
              {/* Email */}
              <div className="mb-5">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  placeholder="user@example.com"
                  className="block w-full h-12 rounded-[10px] border border-neutral-300 px-4 text-black outline-none focus:ring-2 focus:ring-[#184D47]/40 focus:border-[#184D47]"
                />
              </div>

              {/* Password */}
              <div className="mb-5">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  placeholder="••••••••"
                  className="block w-full h-12 rounded-[10px] border border-neutral-300 px-4 text-black outline-none focus:ring-2 focus:ring-[#184D47]/40 focus:border-[#184D47]"
                />
              </div>

              {/* Remember & Forgot */}
              <div className="mb-6 flex items-center justify-between">
                <label className="inline-flex items-center gap-2 select-none cursor-pointer">
                  <input
                    type="checkbox"
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                    className="h-4 w-4 rounded border-neutral-300 text-[#184D47] focus:ring-[#184D47]"
                  />
                  <span className="text-sm text-gray-600">Ingat saya</span>
                </label>
                <a
                  href="http://localhost:1234/#"
                  className="text-sm text-sky-500 hover:text-sky-600"
                >
                  Lupa password?
                </a>
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="w-full h-12 rounded-[10px] bg-[#184D47] text-neutral-50 text-base leading-normal flex items-center justify-center hover:bg-[#133d39] transition-colors"
              >
                Masuk
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Login };
export default Login;
